import React, { useRef, useState } from "react";

import ShopLocatorInfo from "./shopLocatorInfo";
import ShopLocatorSwiper from "./shopLocatorSwiper";
import { useMediaQuery } from "react-responsive";

const RestaurantLocator = ({ store }) => {
  const swiperRef1 = useRef(null);
  const swiperRef2 = useRef(null);
  const [isAutoplay, setIsAutoplay] = useState(true);

  const half = Math.ceil(store.length / 2);
  const firstHalf = store.slice(0, half);
  const secondHalf = store.slice(half);

  const locator = {
    title: "상생매장",
    info: "인기가 많은 상생매장을 알려드릴게요",
    type: "restaurant",
  };

  const toggleAutoplay = () => {
    [swiperRef1, swiperRef2].forEach((ref) => {
      if (ref.current && ref.current.swiper) {
        if (isAutoplay) {
          ref.current.swiper.setTransition(0);
          ref.current.swiper.autoplay.stop();
        } else {
          ref.current.swiper.setTransition(300);
          ref.current.swiper.autoplay.start();
        }
      }
    });
    setIsAutoplay(!isAutoplay);
  };

  return (
    <div className="restaurantInner">
      <ShopLocatorInfo locator={locator} slideEvent={toggleAutoplay} isAutoplay={isAutoplay} />
      <ShopLocatorSwiper type={locator.type} swiperRef={swiperRef1} speed={4000} data={firstHalf} />
      <ShopLocatorSwiper type={locator.type} swiperRef={swiperRef2} data={secondHalf} />
    </div>
  );
};

export default RestaurantLocator;
